

































































































































































































































































































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, IResource, ObjectCollection} from 'simpli-web-sdk'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import {getResponsavel, getRegraExibicaoGrupoEconomico, ItrackCollection} from '@/helpers'
import Motorista from '@/model/resource/Motorista'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import * as Helper from '@/helpers'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'

@Component({
  components: {ItDateInput, VueMultiselect},
})
export default class FilterDelivery extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryRequest
  @Prop({type: Array, default: () => []}) hidden!: string[]
  @Prop({type: Array, default: () => []}) shown!: string[]
  @Prop({type: Array, default: () => []}) blocked!: string[]

  allMotorista = ItrackCollection.allMotoristaFiltro
  showPesquisarDestinatario = Helper.isSpinel() && this.shown.includes('nomeDestinatario')

  get motoristaResource() {
    return this.allMotorista.get(this.value.idMotorista)
  }

  set motoristaResource(val: Motorista | null) {
    this.value.idMotorista = (val && val.$id) || null
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.value.populateAllDocs(cache)
  }

  searchByCTEEvent(item: IResource, cache: IResource[]) {
    this.value.populateSearchByCTE(cache)
  }

  async mounted() {
    if (this.hidden.includes('semOcorrencia')) {
      this.value.allEvent.remove(2)
    }

    if (this.value.status) {
      const statusList = String(this.value.status).split(',')
      this.value.selectedStatusList = statusList.reduce((acc: IResource[], item) => {
        const resource = this.value.allStatus.items.find((status) => String(status.$id) === item)
        if (resource) {
          acc.push(resource)
        }
        return acc
      }, [])
    }

    await this.allMotorista.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoOcorrenciaFiltro.query()
    await this.value.allAuditoriaMotivoFiltro.query()
    await this.value.allTipoInsumo.query()

    const filterNaoDevolvida = this.value.allTipoOcorrenciaFiltro.items.filter(
      (item) =>
        // @ts-ignore
          item.responsavel.$id === getResponsavel().$id || !item.responsavel.$id,
    )

    this.value.tipoOcorrenciaNaoDevolvidaCollection = Helper.collect(
      TipoOcorrencia,
      filterNaoDevolvida,
    )

    this.$await.done('filterQuery')
  }

  cleanDocs() {
    this.value.cleanDocs()
  }

  cleanCtes() {
    this.value.cleanCtes()
  }

  cleanSearchByCtes() {
    this.value.cleanSearchByCTE()
  }

  handleStatusInput(selectedItems: IResource[]) {
    this.value.handleStatusInput(selectedItems)
  }

  customLabel(item: IResource) {
    return item.$tag
  }

  disabledDateField(field: string) {
    const dataPrevisao = this.value.dataPrevisaoInicio || this.value.dataPrevisaoFim
    const dataCriacao = this.value.startDate || this.value.endDate
    const dataEntrega = this.value.dataEntregaInicio || this.value.dataEntregaFim

    if (field === 'dataCriacao') {
      if (dataPrevisao || dataEntrega) return true
    } else if (field === 'dataPrevisao') {
      if (dataCriacao || dataEntrega) return true
    } else if (field === 'dataEntrega') {
      if (dataCriacao || dataPrevisao) return true
    }

    return false
  }

  @Watch('value.placaVeiculo')
  hideTooltip() {
    this.$tip.hideAll()
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
